module.exports = __webpack_public_path__ + "static/img/AdobeStock_207095457.6e17718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AdobeStock_207095457.jpg
// module id = 1508
// module chunks = 5